// pages/ReturnPage/ReturnPage.jsx
import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

const ReturnPage = () => {
  const [status, setStatus] = useState(null);
  const [email, setEmail] = useState('');
  const [error, setError] = useState(null);

  useEffect(() => {
    const sessionId = new URLSearchParams(window.location.search).get('session_id');

    if (!sessionId) {
      setError('Missing session ID in URL');
      return;
    }

    const fetchSessionStatus = async () => {
      try {
        const res = await fetch(`https://377storage.vip/api/stripe/session-status?session_id=${sessionId}`);
        if (!res.ok) {
          const text = await res.text();
          throw new Error(`Backend error: ${res.status} - ${text}`);
        }

        const data = await res.json();
        setStatus(data.status);
        setEmail(data.customer_email);
      } catch (err) {
        console.error('Error fetching session status:', err.message);
        setError(err.message);
      }
    };

    fetchSessionStatus();
  }, []);

  if (error) return <p>Error: {error}</p>;
  if (status === 'open') return <Navigate to="/checkout" />;
  if (status === 'complete') {
    return (
      <section>
        <h2>Payment Complete</h2>
        <p>Thank you! A confirmation email has been sent to {email}.</p>
      </section>
    );
  }

  return <p>Loading...</p>;
};

export default ReturnPage;

